// Port of api/fuel/app/classes/filter/search/games/rules/query/play_worth.php
import Rule from 'offline/filter/core/search/rule'

export default Rule.create({
	name: 'play_worth',
	field: function() { return '!uc_avg' },
	pre: function(rule, config, filter, data, query) {
		query.select('c.collection_value / c.collection_plays', 'uc_avg')
		query.where('c.collection_plays', '>', 0)
	}
})
